var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeaturedContent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.25 2.25L31.045 7.0625L26.25 9.25L31.045 11.455L33.25 16.25L35.4375 11.455L40.25 9.25L35.4375 7.0625M15.75 7.5L11.375 17.125L1.75 21.5L11.375 25.875L15.75 35.5L20.125 25.875L29.75 21.5L20.125 17.125M33.25 26.75L31.045 31.545L26.25 33.75L31.045 35.9375L33.25 40.75L35.4375 35.9375L40.25 33.75L35.4375 31.545",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturedContent);
export default __webpack_public_path__ + "static/media/featured-content.8dfbf3df360c9454ec39c9cbfda7051f.svg";
export { ForwardRef as ReactComponent };